import React from 'react';

interface VideoComponentProps {
  src?: string;
}

const VideoComponent = ({
  src = '',
}: VideoComponentProps): React.JSX.Element => (
  <div className="w-full mobile:mb-6 xs:mb-8">
    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
    <video src={src} className="flex h-auto w-full" controls />
  </div>
);

export default VideoComponent;
